import React, { useEffect, useState } from 'react';

import KOGImageGroup from '@/main/components/shared/kogImage/kogImageGroup/kogImageGroup';
import { PartDetailBySupplierInventoryResponse } from '@/main/models/response';
import { getTranslateByKey } from '@/main/services/utils';

import { partApi } from '@/main/api';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import { IMAGE_DEFAULT } from '@/main/services/constants';
import { toast } from 'react-toastify';
import KogModalSlideImages from '../../../../../../components/shared/KogModalSlideImages/modalSlideImages';
import * as S from './styles';

interface IModalPartDetails {
  closeModal: (value: React.SetStateAction<boolean>) => void;
  quoteSupplierItem?: boolean;
  guid: string | null;
}

function ModalPartDetails({
  closeModal,
  quoteSupplierItem = false,
  guid
}: IModalPartDetails) {
  const [detailSupplier, setDetailSupplier] =
    useState<PartDetailBySupplierInventoryResponse | null>(null);
  const [loadingSupplierDetails, setLoadingSupplierDetails] =
    useState<boolean>(false);
  const [imageIndex, setImageIndex] = React.useState(0);
  const [isOpenModalFade, setIsOpenModalFade] = React.useState<boolean>(false);

  useEffect(() => {
    setLoadingSupplierDetails(true);
    if (guid) {
      partApi
        .getPartDetailBySupplierInventory(
          quoteSupplierItem ? { guidQuoteSupplierItem: guid } : { guid: guid }
        )
        .then(response => {
          const resultData = response.data.result;
          setDetailSupplier(resultData);
        })
        .catch(() => {
          closeModal(false);
        })
        .finally(() => {
          setLoadingSupplierDetails(false);
        });
    } else {
      closeModal(false);
      toast.error(
        getTranslateByKey('partDetail.notPossibleOpenDetails,', true)
      );
    }
  }, [guid]);

  if (loadingSupplierDetails) return <LoadingComponent />;

  return (
    <S.Container>
      <h4>{getTranslateByKey('quotation.partDetail')}</h4>
      <KOGImageGroup
        images={detailSupplier?.imageUrls ?? [IMAGE_DEFAULT]}
        setImageIndex={setImageIndex}
        onCLickCustomAreaCurrentImage={() => {
          setIsOpenModalFade(true);
        }}
      />
      <S.TitlePart>
        <strong>{String(detailSupplier?.partCode)}</strong> -{' '}
        {detailSupplier?.partTitle}
      </S.TitlePart>
      <p>{detailSupplier?.partDescription}</p>
      <S.FooterModal>
        <SecondaryButton
          id="id-createAnswerCarts-btn-backModal"
          type="button"
          onClick={() => closeModal(false)}>
          {getTranslateByKey('information.close')}
        </SecondaryButton>
      </S.FooterModal>

      {detailSupplier?.imageUrls && detailSupplier.imageUrls.length > 0 && (
        <KogModalSlideImages
          images={detailSupplier.imageUrls}
          imageIndex={imageIndex}
          isOpen={isOpenModalFade}
          setIsOpen={setIsOpenModalFade}
          isInModal
        />
      )}
    </S.Container>
  );
}

export default ModalPartDetails;
